import { useContext, useCallback } from 'react';
import { formatListData, AjaxContext } from 'commons-ui';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const getMttSchemaData = useCallback(
		async ({
			app,
			pageDetails,
			sortDetails,
			filterDetails
		}: {
			app: { appName: string };
			pageDetails: any;
			sortDetails: any;
			filterDetails: any;
		}) => {
			const response = await postData({
				endpoint: '/marketing/dashboard/mttSchema/getMttSchema',
				body: {
					page: pageDetails,
					filters: filterDetails,
					sortInfoArray: sortDetails,
					gameName: 'ludo'
				},
				queryParams: {
					appName: app.appName
				}
			});
			const listData = formatListData(response?.data?.data);
			return { rowCount: listData.length, data: listData };
		},
		[]
	);

	const requestCreateSchema = useCallback((appName: any, data: any) => {
		return postData({
			endpoint: '/marketing/dashboard/mttSchema/createMttSchema',
			body: { ...data, isGold: data.isGold, gameName: 'ludo' },
			queryParams: { appName }
		});
	}, []);

	const requestUpdateSchema = useCallback((appName: any, data: any) => {
		return postData({
			endpoint: '/marketing/dashboard/mttSchema/updateMttSchema',
			body: { ...data, isGold: data.isGold, gameName: 'ludo' },
			queryParams: { appName }
		});
	}, []);

	const requestDeleteSchema = useCallback((appName: any, data: any) => {
		return postData({
			endpoint: '/marketing/dashboard/mttSchema/deleteMttSchema',
			body: { mttSchemaId: data._id, gameName: 'ludo' },
			queryParams: { appName }
		});
	}, []);

	const requestCreateSchemaBulk = useCallback((appName: any, data: any) => {
		return postData({
			endpoint: '/marketing/dashboard/mttSchema/createMttSchemaBulk',
			body: { ...data, isGold: true, gameName: 'ludo' },
			queryParams: { appName }
		});
	}, []);

	return {
		getMttSchemaData,
		requestUpdateSchema,
		requestDeleteSchema,
		requestCreateSchema,
		requestCreateSchemaBulk
	};
};

export default useService;
